module.exports = __webpack_public_path__ + "static/media/read_content_aloud_marathi.66a130a7.mp3";